<template>
  <div>
    <el-select ref="select" @focus="clear" @hook:mounted="clear" @visible-change="handleVisibleChange" @blur.native.capture="onblur" v-el-select-loadmore="loadMore" :popper-append-to-body="false" :filterable="true" :remote="true" :remote-method="handleRemote" :value="value" value-key="id" :placeholder="placeholderText" :size="size" @input="change($event)" :clearable="true" @clear="handleRemote" popper-class="product-select-dropdown" :disabled="disabled">
      <el-option v-if="!config" label="----------" :value="emptyValue" />
      <el-option v-for="item in optionsReader()" :key="item.id" :label="item.package ? item.desc + '【'+ item.package.desc +'】' : item.desc" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import { fetchProductList } from '../api/product'
import {debounce} from '../../utils'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: [],
      configOptions: null,
      optionsReader: () => { if (this.config) { return this.configOptions } return this.options },
      list: [],
      formData: {
        pageIndex: 1,
        pageSize: 10
      },
      dropDownValue: ''
    }
  },
  computed: {
    placeholderText () {
      return this.searchMode === 'package' ? this.$t('card.packages') : this.$t('card.product')
    }
  },
  created () {
    // fetchProductList({limit: 0}).then((res) => {
    //   this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    //   this.configOptions = this.config ? this.options.filter((item) => { return item.id === parseInt(this.config.selected) }) : this.options
    // })
  },
  mounted () {
  },
  props: ['value', 'config', 'size', 'showAllTip', 'showAllTipLabel', 'disabled', 'searchMode'],
  methods: {
    clear (async) {
      this.dropDownValue = ''
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const { select } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    },
    handleVisibleChange (visible) {
      this.clear()
      if (visible) {
        this.$nextTick(() => {
          setTimeout(() => {
            const { select } = this.$refs
            const inputWidth = select.$el.offsetWidth
            const dropdown = select.$el.querySelector('.el-select-dropdown')
            dropdown.style.width = inputWidth + 'px'
            if (this.options.length === 0) {
              this.handleUpdate(false)
            }
          }, 10)
        })
      }
    },
    // 失去焦点时，需要把软键盘收起
    onblur () {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur()
        }
      })
    },
    handleRemote (data) {
      debounce(() => {
        this.dropDownValue = data
        this.options = []
        this.handleUpdate(false)
      }, 2000, true)()
    },
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate (loadMore = false) {
      let q = []
      let query = {}
      let wt = []
      let wq = []
      // 如果加载更多，页数+1，否则恢复初始值
      if (loadMore) {
        this.formData.pageIndex += 1
        this.list = this.options
        console.log('加载更多')
      } else {
        this.formData.pageIndex = 1
        this.list = []
        console.log('初次加载')
      }
      query.limit = this.formData.pageSize
      query.page = this.formData.pageIndex
      console.log(query)
      if (this.dropDownValue) {
        if (this.searchMode === 'package') {
          q.push(['like', 'desc', '%'].join(','))
          wt.push(['card_package', 'package_id', 'id'].join(','))
          wq.push(['like', 'card_package.desc', '%' + this.dropDownValue + '%'].join(','))
        } else {
          q.push(['like', 'desc', '%' + this.dropDownValue + '%'].join(','))
        }
      }
      query.q = q.join('&')
      query.wt = wt.join(';')
      query.wq = wq.join('&')
      fetchProductList(query).then((res) => {
        const _res = res.data.map((item) => { item.id = parseInt(item.id); return item })
        if (_res.length > 0) {
          this.options = [...this.list, ..._res]
        }
      })
    },
    loadMore () {
      this.handleUpdate(true)
    }
  },
  watch: {
    config: function (val, old) {
      this.configOptions = val ? this.options.filter((item) => { return item.id === parseInt(val.selected) }) : this.options
    }
  },
  directives: {
    'el-select-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight + 1
          if (condition && this.scrollTop !== 0) {
            binding.value()
          }
        })
      }
    }
  }
}
</script>

<style scoped>
::v-deep .product-select-dropdown .el-select-dropdown__item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/card/components/ProductSelect.vue